import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StatusSetting } from '../channel-panel-alarm/channel-panel-alarm.component';
import { contactStatusMaxLength } from 'icreate/common/validators/alarm-settings/alarm-setting-validator';

type ContactKey = 'statusStringContactOn' | 'statusStringContactOff';

interface ContactState {
    key: ContactKey;
    labelKey: string;
    placeholderKey: string;
}

@Component({
    selector: 'app-channel-panel-alarm-contact',
    templateUrl: './channel-panel-alarm-contact.component.html',
    styleUrls: ['./channel-panel-alarm-contact.component.scss'],
    standalone: false,
})
export class ChannelPanelAlarmContactComponent {
    @Input() statusSetting: StatusSetting;
    @Input() isShowSelect: boolean;
    @Input() isEnabled: boolean;
    @Input() digitalAlarmSetting: Record<ContactKey, string>;

    @Output() onSwapStatus = new EventEmitter<void>();
    @Output() onChange = new EventEmitter<void>();

    readonly StatusSetting = StatusSetting;
    readonly CONTACT_STATUS_MAX_LENGTH = contactStatusMaxLength;

    readonly contactStates: ContactState[] = [
        {
            key: 'statusStringContactOn',
            labelKey: 'channel.alarm.label.contact.on',
            placeholderKey: 'channel.alarm.placeholder.contact.on',
        },
        {
            key: 'statusStringContactOff',
            labelKey: 'channel.alarm.label.contact.off',
            placeholderKey: 'channel.alarm.placeholder.contact.off',
        },
    ];

    private readonly touchedKeys = new Set<ContactKey>();

    isTouched(key: ContactKey): boolean {
        return this.touchedKeys.has(key);
    }

    onBlur(key: ContactKey): void {
        this.touchedKeys.add(key);
    }

    resetTouched(): void {
        this.touchedKeys.clear();
    }
}
